import {Company} from './company';
import {UserRole} from './user-role';
import {UserContent} from './user-content';
import {UserBadge} from './user-badge';
import { Group } from 'shared/models/target-groups/group';
import { Category } from 'shared/models/target-groups/category';

export class User {
  public _id: number;
  public email: string;
  public firstname: string;
  public lastname: string;
  public password: string;
  public roles: Array<UserRole>;
  public groups: Array<Group>;
  public categories: Array<Category>;
  public active: boolean;
  public company: Company;
  public createdAt: Date;
  public updatedAt: Date;
  public lastUsedAt: Date;
  public settings: object;
  public badges: Array<UserBadge>;
  public contents: Array<UserContent>;
  public devicetypes: Array<string>;

  constructor(id?: number) {
    this._id = id;
    this.active = false;
    this.company = <Company> {};
  }

  public static create(data: User): User {
    const user: User = new User(data._id);
    user.email = data.email;
    user.firstname = data.firstname;
    user.lastname = data.lastname;
    user.active = data.active;
    user.createdAt = new Date(data.createdAt);
    user.updatedAt = new Date(data.updatedAt);
    user.devicetypes = data.devicetypes;

    if (data.company) {
      if (data.company._id)
        user.company = data.company;
      else
        user.company = <Company> {_id: '', name: '' + data.company};
    } else {
      user.company = <Company> {};
    }
    user.roles = data.roles;
    user.groups = data.groups;
    user.categories = data.categories;

    if (data.settings) {
      user.settings = data.settings;
    }

    if (data.badges) {
      user.badges = data.badges;
    }
    if (data.contents) {
      user.contents = data.contents;
    }
    if (data.lastUsedAt) {
      user.lastUsedAt = new Date(data.lastUsedAt);
    }
    else {
      user.lastUsedAt = null;
    }

    return user;
  }

  public getRolesAsText(): string {
    return this.roles.map((role: UserRole) => role.name).join(', ');
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/classes/user.ts